// extracted by css-extract-rspack-plugin
export default {"layoutWrapper":"layoutWrapper-iYqK0C","mainColumn":"mainColumn-k5Au0p","mainContent":"mainContent-_Q3YH7","rightRail":"rightRail-iZO9zF","mobilePetTile":"mobilePetTile-MgLRPx"};